import type { ConceptDef } from '../types';

export const sequenceAlphabet: ConceptDef = {
  kind: 'sequenceTap',
  id: 'sequence-alphabet',
  label: 'Sequence Alphabet',
  category: 'Sequencing',
  description: 'Tap letters in alphabetical order.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Tap A to F in order.', items: ['A', 'B', 'C', 'D', 'E', 'F'] },
      { label: 'Tap G to L in order.', items: ['G', 'H', 'I', 'J', 'K', 'L'] },
    ],
  },
};
